import { Code2, HeartHandshake, TrendingUp, Home } from "lucide-react";

export const values = [
  {
    icon: Code2,
    title: "Engineering Over Shortcuts",
    copy: "We build systems meant to run for years. No duct-tape solutions, no disappearing after launch.",
  },
  {
    icon: HeartHandshake,
    title: "Real Client Impact",
    copy: "Your work runs inside real businesses — clinics, CA firms, startups. You'll see exactly what it changes.",
  },
  {
    icon: TrendingUp,
    title: "Growth & Ownership",
    copy: "Own features end to end. Small team, real responsibility, and room to grow into the role you want.",
  },
  {
    icon: Home,
    title: "Remote / Flexible Culture",
    copy: "Work from where you work best. We care about output and craft, not clock-watching.",
  },
];

export const gallery = [
  {
    src: "https://images.pexels.com/photos/23496662/pexels-photo-23496662.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "Team collaborating on a system architecture whiteboard",
    label: "Team",
  },
  {
    src: "https://images.pexels.com/photos/27141307/pexels-photo-27141307.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "Dashboard interface from a client system build",
    label: "Projects",
  },
  {
    src: "https://images.pexels.com/photos/8204363/pexels-photo-8204363.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "Workspace during a client systems review",
    label: "Workspace",
  },
  {
    src: "https://images.pexels.com/photos/27141316/pexels-photo-27141316.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "Reports and analytics view behind the scenes",
    label: "Behind the scenes",
  },
  {
    src: "https://images.unsplash.com/photo-1631248055158-edec7a3c072b?auto=format&fit=crop&w=900&q=70",
    alt: "A clinic where one of our system concepts would run",
    label: "In the field",
  },
  {
    src: "https://images.unsplash.com/photo-1670589953882-b94c9cb380f5?auto=format&fit=crop&w=900&q=70",
    alt: "Real estate site visit for a CRM rollout",
    label: "On location",
  },
];

// ============================================================
// SEED ROLES — edit or remove freely. Set `open: false` or
// delete an entry to unpublish it.
// ============================================================
export const roles = [
  {
    id: "fullstack-developer",
    title: "Full-Stack Developer",
    type: "Full-time",
    location: "Remote / Hybrid",
    description:
      "Build client systems end to end — React frontends, API backends, databases and the integrations between them. You should care about clean, simple code that survives real users.",
  },
  {
    id: "ui-ux-designer",
    title: "UI/UX Designer",
    type: "Full-time",
    location: "Remote / Hybrid",
    description:
      "Design premium interfaces for websites, dashboards and internal tools. You think in systems and user flows, not just screens, and you can defend every decision with a business reason.",
  },
  {
    id: "ai-automation-engineer",
    title: "AI/Automation Engineer",
    type: "Full-time",
    location: "Remote",
    description:
      "Design and build AI agents, chatbots and workflow automations that take repetitive work off real teams. Practical outcomes over demos — every automation must survive production.",
  },
  {
    id: "crm-backend-developer",
    title: "CRM/Backend Developer",
    type: "Full-time",
    location: "Remote / Hybrid",
    description:
      "Build the systems behind the systems: custom CRMs, role-based backends, reporting pipelines and dashboards. Strong data modelling and API design are a must.",
  },
  {
    id: "seo-specialist",
    title: "SEO Specialist",
    type: "Full-time",
    location: "Remote",
    description:
      "Own technical SEO, Core Web Vitals, schema and content strategy for client websites. You report on enquiries and pipeline, not vanity metrics.",
  },
  {
    id: "project-manager",
    title: "Project Manager",
    type: "Full-time",
    location: "Hybrid",
    description:
      "Run discovery, scoping and delivery across multiple client systems. You translate business problems into clear requirements and keep builds honest, on time and on scope.",
  },
];
